<template>
  <div class="app-container" id="account">
    <el-form>
      <el-col :span="24" style="padding-bottom: 10px; margin: 10px 10px">
        <el-form-item label="搜索">
          <el-input
            v-model="form.searchKey"
            placeholder="请输入要查询的代理商账号或代理商名称"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="mac日期搜索" style="margin-left:20px">
          <el-date-picker
                v-model="form.macdate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                @change="onPick"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              ></el-date-picker>
        </el-form-item>
        <el-form-item class="searck_agent_btn">
          <el-button
            type="goon"
            icon="el-icon-search"
            @click="search()"
          ></el-button>
        </el-form-item>
        <el-form-item label="直装mac日活：" style="margin-left:20px">
          {{selfmacLive}}
        </el-form-item>
         <el-form-item label="下级mac日活总和：" style="margin-left:20px">
          {{nextmacLiveAll}}
        </el-form-item>
        <!-- <el-form-item
          style="float: right;"
          v-if="deployclient_show"
        >
          <el-button type="goon" size="medium"><a :href="deployclienturlzip">部署扫码客户端.zip</a>  </el-button>
          <el-button type="goon" size="medium"><a :href="deployclienturlexe">部署扫码客户端.exe</a>  </el-button>
        </el-form-item> -->
        <!-- <el-form-item  v-if="agent_type">
          <el-button type="goon" size="medium" @click="addAgent = true">
            <i class="el-icon-circle-plus"></i>&nbsp; 创建代理商
          </el-button>
        </el-form-item> -->
      </el-col>
    </el-form>

    <template v-if="agentListBoolean">
      <el-col :span="24">
        <div class="dls_list app-containerTest">
          <div class="table_title">mac日活列表</div>
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
            element-loading-text="数据加载，请稍后......"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.5)"
            key="tableDataInstall1"
            :sort-orders="['ascending', 'descending']"
            :default-sort="{ prop: 'agentCount', order: 'descending' }"
            @sort-change="sortChange"
          >
          
            <el-table-column
              label="代理商账号"
              prop="account"
              align="center"
            ></el-table-column>
            <el-table-column
              label="代理商名称"
              prop="name"
              align="center"
            ></el-table-column>
            <el-table-column
              label="渠道号"
              prop="channel"
              align="center"
            ></el-table-column>
            <el-table-column
              label="账号类型"
              prop="type"
              align="center"
              v-if="showAccount"
              :render-header="renderEmotionValue"
            >
              <template slot-scope="scoope">
                <span>{{ scoope.row.type }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="下级直装mac日活"
              prop="selfMac"
              align="center"
            ></el-table-column>
            <el-table-column
              label="下级代理mac日活"
              prop="nextMac"
              align="center"
            ></el-table-column>
            
            <!-- <el-table-column
              label="下级代理数"
              prop="agentCount"
              sortable
              align="center"
            ></el-table-column>
            <el-table-column
              label="充值终端数"
              prop="qcodePayCount"
              align="center"
            ></el-table-column>
            <el-table-column
              label="扫码终端数"
              prop="qcodeBarCount"
              align="center"
            ></el-table-column>
            <el-table-column
              label="账号状态"
              prop="status"
              align="center"
            ></el-table-column> -->
            <!-- <el-table-column
              label="操作"
              prop="operation"
              align="center"
              width="620"
              v-if="deployclient_show"
            >
              <template slot-scope="scope"  >
                <el-button size="small" type="primary"></el-button> -->
                
                <!-- <el-button
                  size="small"
                  type="warning"
                  @click="resetBtn(scope.row)"
                >
                  重置密码
                </el-button> -->

                <!-- <el-button size="small" type="danger" @click="deleteBtn(scope.$index,scope.row)">
                      删除
                  </el-button> -->
              <!-- </template>
            </el-table-column> -->
          </el-table>
        </div>
        <!--分页条-->
        <el-pagination
          style="padding-bottom: 0px"
          :total="total"
          background
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
        ></el-pagination>
      </el-col>
    </template>

    <!-- 删除 -->
    <el-dialog :title="title" :visible.sync="deleteVisible" width="30%" center>
      <div>{{ info }}</div>
      <div slot="footer" class="edit-footer">
        <el-button @click="deleteVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleGoodsOkbtn()">确定</el-button>
      </div>
    </el-dialog>

    <!-- 添加商品 -->
    <el-dialog
      :title="addagenttitle"
      :visible.sync="addAgent"
      width="30%"
      center
      class="agent_add_a"
    >
      <el-form
        label-width="140px"
        label-position="left"
        :model="addAgentData"
        :rules="rules"
        ref="addAgentData"
      >
        <el-form-item label="代理商账号" prop="agent_account">
          <el-input
            v-model="addAgentData.agent_account"
            placeholder="请输入至多不超过20位的账号"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="代理商名称" prop="agent_name">
          <el-input
            v-model="addAgentData.agent_name"
            placeholder="请输入代理商名称"
          ></el-input>
        </el-form-item>
        <el-form-item style="color:red" label="代理商分成比例" prop="agent_name">
          <p>{{shareratiotips}}</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="edit-footer">
        <el-button @click="addAgentCancel()">取 消</el-button>
        <el-button type="primary" @click="addAgentOkbtn('addAgentData')"
          >确定添加</el-button
        >
      </div>
    </el-dialog>

    <!-- x修改商品 -->
    <el-dialog
      title="编辑商品"
      :visible.sync="changeAgent"
      width="30%"
      center
      class="agent_add agent_add_a"
    >
      <el-form
        label-width="140px"
        label-position="left"
        :model="changeAgentData"
        :rules="rules2"
        ref="changeAgentData"
      >
        <el-form-item label="代理商账号" prop="agent_account">
          <el-input
            v-model="changeAgentData.account"
            disabled
            placeholder="请输入至多不超过15位的账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="代理商名称" prop="agent_name">
          <el-input
            v-model="changeAgentData.name"
            disabled
            placeholder="请输入代理商名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="扫码分成比例（%）" prop="ScanRatio">
          <el-input
            v-model="changeAgentData.ScanRatio"
            :inline="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="终端包月单价（元）" prop="byUprice">
          <el-input
            v-model="changeAgentData.byUprice"
            :inline="true"
            placeholder="请输入小于999的数值"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="edit-footer">
        <el-button @click="changeAgent = false">取 消</el-button>
        <el-button type="primary" @click="changeOkBtn('changeAgentData')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import * as sysApi from "../../common/sys";
import {formatDate} from "../../common/utils";

export default {
  data() {
    var checkRemark = (rule, value, callback) => {
      if (value.length > 16) {
        callback(new Error("备注信息长度不能大于16"));
      } else {
        callback();
      }
    };

    var validateDuration = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入代理商名称"));
      } else if (value.length > 16) {
        callback(new Error("请输入16字符以内的代理商名称"));
      }
      callback();
    };
    var validateProductPrice = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入扫码分成比例"));
      } else if (!/^\+?[1-9][0-9]*$/.test(value)) {
        callback(new Error("扫码分成比例必须为正整数"));
      } else if (value > 70) {
        callback(new Error("扫码分成比例必须0~70以内正整数"));
      }
      callback();
    };
    var validateProductSort = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入包月充值价格"));
      } else if (value > 999) {
        callback(new Error("请输入包月充值价格不得大于999"));
      }
      callback();
    };
    var validatescan_ratio = (rule, value, callback) => {
      console.log(value);
      if (value === "") {
        callback(new Error("请输入扫码分成比例"));
      } else if (!/^(?:0|[1-9][0-9]?|70)$/.test(value)) {
        callback(new Error("扫码分成比例必须0~70以内正整数"));
      }
      callback();
    };
    var validatemonthly_charge_price = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入包月充值价格"));
      } else if (value > 999) {
        callback(new Error("请输入包月充值价格不得大于999"));
      }
      callback();
    };
    var validatecy_bar_name = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入网吧名称"));
      } else if (value.length > 16) {
        callback(new Error("请输入15位以内字符"));
      }
      callback();
    };
    var validatebar_count = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入终端数量"));
      } else if (!/^[0-9]+$/.test(value) || value > 9999) {
        callback(new Error("请输入大于0小于9999的整数"));
      }
      callback();
    };
    var validateid = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入网吧IP"));
      } else if (/^[\u2E80-\u9FFF]+$/.test(value)) {
        callback(new Error("请输入非汉字"));
      } else if (value.length > 32) {
        callback(new Error("请输入不超过32位字符"));
      }
      callback();
    };
    var validateagent = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入代理商账号"));
      } else if (!/^[a-zA-Z0-9]{1,20}$/.test(value)) {
        callback(new Error("请输入20位以内的英文或数字"));
      }
      callback();
    };
    var validatescan_Name = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入网吧名称"));
      } else if (value.length > 16) {
        callback(new Error("请输入15位以内字符"));
      }
      callback();
    };
    var validatemonthly_count = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入终端数量"));
      } else if (value < 10) {
        callback(new Error("请输入至少10台的终端数量"));
      }
      callback();
    };

    var validatemonthly_ip = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入网吧ip"));
      } else if (/^[\u2E80-\u9FFF]+$/.test(value)) {
        callback(new Error("请输入非汉字"));
      } else if (value.length > 32) {
        callback(new Error("请输入不超过32位字符"));
      }
      callback();
    };
    return {
      nextmacLiveAll:"",
      selfmacLive:"",
      showBar: true, //是否禁用编辑网吧dialog 网吧名称input
      showBarCount: true, //是否禁用编辑网吧dialog 终端数量input
      showBtn: true,
      showSpan: false,
      showAccount: false,
      changeBarDialog: false,
      loading: false,
      loading2: false,
      onelevel: false,
      twolevel: false,
      gd: false,
      barListBoolean: false,
      agentListBoolean: true,
      //  amountShow:false,
      own_level_name: "",
      title: "",
      addBarData: {
        cy_bar_name: "",
        ip: "",
        price: "",
        bar_count: 20,
        amount: "",
        id: "",
        bar_remark: "",
      },
      statusAgent: false,
      statusDes: "",
      look: false,
      chargeAgent: false,
      info: "",
      limit: false,
      limitBar: false,
      ipNo: false,
      form: {
        macdate:"",
        barStatus: "全部",
        level: "国代",
        bybarAccout: "",
        allSpeedAmount: "", //包月加速总人次
        gdAmount: "",
        oneAgents: "",
        twoAgents: "",
        searchKey: "",
        totalAmount: "",
        agentAmount: "",
        agentBalance: "",
        qrcodeAmount: "",
        qrcodeBalance: "",
        userAgents: "",
        userQrcode: "",
      },
      saoData: {
        ordersn: "",
        time: "",
        amount: "",
      },
      tableData: [],
      tableData1: [],
      changeAgent: false,
      czRules: {
        count: [{ validator: validatemonthly_count, trigger: "blur" }],
        recharge_time: [
          { required: true, message: "请选择时长", trigger: "change" },
        ],
      },
      rules: {
        agent_account: [{ validator: validateagent, trigger: "blur" }],
        agent_name: [{ validator: validateDuration, trigger: "blur" }],
        scan_code_ratio: [{ validator: validateProductPrice, trigger: "blur" }],
        recharge_price: [{ validator: validateProductSort, trigger: "blur" }],
      },
      rulesbar: {
        cy_bar_name: [{ validator: validatecy_bar_name, trigger: "blur" }],
        bar_count: [{ validator: validatemonthly_count, trigger: "blur" }],
        id: [{ validator: validateid, trigger: "blur" }],
        bar_remark: [{ validator: checkRemark, trigger: "blur" }],
      },
      rules2: {
        ScanRatio: [{ validator: validatescan_ratio, trigger: "blur" }],
        byUprice: [
          { validator: validatemonthly_charge_price, trigger: "blur" },
        ],
      },
      rules3: {
        Name: [{ validator: validatescan_Name, trigger: "blur" }],
        count: [{ validator: validatemonthly_count, trigger: "blur" }],
        bar_remark: [{ validator: checkRemark, trigger: "blur" }],
      },
      ipRules: {
        validateIp: [
          {
            validator: (rule, value, callback) => {
              if (
                !/^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/.test(
                  value
                )
              ) {
                callback(new Error("请输入合法IP"));
              }
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
      },
      start_at:"",
      end_at:"",
      total: 1,
      total1: 1,
      isShowDetail: false,
      deleteVisible: false,
      addAgent: false,
      addBar: false,
      addAgentData: {
        agent_account: "",
        agent_name: "",
        scan_code_ratio: "",
        recharge_price: "",
      },
      changeBarDialogData: {
        Name: "",
        ip: "",
        count: "",
        bar_remark: "",
      },
      currentPage: 1,
      currentPage1: 1,
      el_ti: "",
      chargeSaoAgent: true,
      changeAgentData: {
        ScanRatio: "",
        byUprice: "",
        name: "",
        account: "",
      },
      sort: 1, //默认排序下级代理书从大到小
      chargeAgentData: {
        ip: "",
        price: "",
        recharge_price: 0.0,
        recharge_time: "",
        recharge_type: "微信",
        timeshiji: "",
        count: "",
      },
      AnchorMember: [
        { id: 1, label: "国代" },
        { id: 2, label: "一级代理" },
        { id: 3, label: "二级代理" },
      ],
      barStatusArr: [
        { id: 0, label: "全部" },
        { id: 1, label: "试用中" },
        { id: 2, label: "正常" },
        {
          id: 3,
          label: "已到期",
        },
        { id: 4, label: "未激活" },
      ],
      rechargeTime: [
        { id: 1, label: "1个月" },
        { id: 2, label: "2个月" },
        { id: 3, label: "3个月(赠送1个月)" },
        { id: 6, label: "6个月(赠送3个月)" }
      ],
      countNumber: "",
      level_own: "",
      three_id: "",
      rowId: "",
      img: "",
      agent: "全部",
      index: "",
      flag: "",
      showBindIpMac: false, //绑定网吧ip mac弹窗
      bindBarForm: {
        ip_switch: false,
        ip_list: [],
        mac_switch: false,
        mac_list: "",
        ip_list: [
          {
            value: "",
          },
        ],
      },
      fileList: [],
      macLength: 0,
      autoUpload: false,
      selectRow: null,
      agent_type: true,
      //部署客户端
      deployclient_show: true,
      deployclienturlzip:"",
      deployclienturlexe:"",
      shareratiotips:"",
      sharerationumber:0,
      addagenttitle:""
    };
  },
  components: {
    QRCode: QRCode,
  },
  mounted() {},
  created() {
    this.form.macdate=[new Date(),new Date()];
    console.log(this.form.macdate);
    this.start_at=formatDate(new Date(),"yy-MM-dd");
    this.end_at=formatDate(new Date(),"yy-MM-dd");
    this.init();
    this.macLiveAll();
   
    // this.agent_type =  localStorage.getItem("agent_type");
    let type = localStorage.getItem("agent_type");

    if (type == "管理员" || type == "区域经理" || type == "三级代理") {
      this.agent_type = false;
    } else {
      this.agent_type = true;
    }
    if (type == "管理员" || type == "区域经理") {
      this.deployclient_show = false;
    } else {
      // this.getdeployclient(); //获取客户端连接
      this.deployclient_show = true;
    }
    if(type=="一级代理"){
      this.shareratiotips="二级代理扫码分成比例为：50%"
      this.sharerationumber="50%"
      this.addagenttitle="创建二级代理商"
    }else if(type=="二级代理"){
      this.shareratiotips="三级代理级扫码分成比例为：40%"
      this.sharerationumber="40%"
      this.addagenttitle="创建三级级代理商"
    }else{
       this.shareratiotips=""
       this.sharerationumber=0
       this.addagenttitle="创建代理商"
    }
    /**初次加载 数据列表 vue axios**/
    if (
      localStorage.getItem("agent_type") == "管理员" ||
      localStorage.getItem("agent_type") == "区域经理"
    ) {
      this.limitBar = false;
      this.limit = true;
      this.showAccount = true;
    } else if (localStorage.getItem("agent_type") == "一级代理") {
      this.limitBar = true;
      this.limit = true;
      this.gd = true;
    } else if (localStorage.getItem("agent_type") == "二级代理") {
      this.limitBar = true;
      this.limit = true;
      this.onelevel = true;
    } else if (localStorage.getItem("agent_type") == "三级代理") {
      this.limitBar = true;
      this.limit = false;
      this.twolevel = true;
    }

    // 统计
    // sysApi
    //   .accountNumber()
    //   .then(data => {
    //     this.form.bybarAccout = data.data.包月网吧数量;
    //     this.form.gdAmount = data.data.国代数量;
    //     this.form.oneAgents = data.data.一级代理数量;
    //     this.form.twoAgents = data.data.二级代理数量;
    //     this.form.allSpeedAmount = data.data.包月加速总人次;
    //     console.log(data);
    //   })
    //   .catch(err => console.log("请求异常信息:" + err));
  },
  methods: {
    onPick(val){
      this.form.macdate=val;
      this.start_at=val[0],
      this.end_at=val[1],
      this.init(this.sort);
      this.macLiveAll();
    },
    //部署客户端
    getdeployclient() {
      let pamrs = localStorage.getItem("agent_number");
      let account_number = "account_number=" + pamrs;
      sysApi.sm_downloads(account_number).then((res) => {
        console.log(res);
        if(res.code==1){
          this.deployclienturlzip=res.result.sm_zip_url;
          this.deployclienturlexe=res.result.sm_exe_url;
        }
        
      });
    },
    sortChange(column, prop, order) {
      console.log(column + "-" + column.prop + "-" + column.order);
      if (column.prop == "agentCount" && column.order == "descending") {
        //降序
        this.sort = 1;
      } else if (column.prop == "agentCount" && column.order == "ascending") {
        this.sort = -1;
      } else if (column.prop == "bybarCount" && column.order == "descending") {
        this.sort = 2;
      } else if (column.prop == "bybarCount" && column.order == "ascending") {
        this.sort = -2;
      } else {
        this.sort = 0;
      }
      this.currentPage = 1;
      this.init(this.sort);
    },

    agentList() {
      this.agentListBoolean = true;
      this.barListBoolean = false;
      this.form.searchKey = "";
      //this.init(this.sort)  sort-change时候已经调用过一次该函数
    },
    barList() {
      this.agentListBoolean = false;
      this.barListBoolean = true;
      this.form.searchKey = "";
      this.form.barStatus = "全部";
      this.init1();
    },

    qrcode() {
      if (this.img == "") {
        return;
      }
      var img = this.img;
      let qrcode = new QRCode("qrcode", {
        width: 100,
        height: 100, // 高度
        text: img, // 二维码内容
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        colorDark: "#000",
        colorLight: "#fff",
      });
    },

    addAgentCancel() {
      this.addAgent = false;
      this.addAgentData.agent_account = "";
      this.addAgentData.agent_name = "";
      this.addAgentData.scan_code_ratio = "";
      this.addAgentData.recharge_price = "";
    },
    // 确定添加代理商
    addAgentOkbtn(formName) {
      if (!this.addAgentData.agent_account) {
        return this.$message({
          type: "error",
          message: "请输入代理商账号",
        });
      }

      if (!this.addAgentData.agent_name) {
        return this.$message({
          type: "error",
          message: "请输入代理商名称",
        });
      }

      var params = {
        account: this.addAgentData.agent_account,
        agent_name: this.addAgentData.agent_name,
      };
      sysApi
        .new_register(params)
        .then((res) => {
          if (res.code != 1) {
            return this.$message.error(res.result);
          }
          this.addAgent = false;
          this.addAgentData.agent_account = "";
          this.addAgentData.agent_name = "";
          this.agentList();
          this.init(this.sort)
          return this.$message.success(res.result);
        })
        .catch((err) => console.log("请求异常信息:" + err));
    },
    // 删除
    deleteBtn(index, row) {
      this.rowId = row.id;
      this.index = index;
      this.deleteVisible = true;
      this.title = "删除";
      this.info = "是否确认删除？";
    },
    resetBtn(row) {
      this.rowId = row.id;
      this.deleteVisible = true;
      this.title = "重置密码";
      this.info = "是否重置" + row.account + "账号的登录密码？";
    },

    deleGoodsOkbtn() {
      if (this.info == "是否确认删除？") {
        var status_type = "del";
      } else if (this.info == "是否确认启用？") {
        var status_type = "enable";
        var status_change = "正常";
      } else if (this.info == "是否确认禁用？") {
        var status_type = "disable";
        var status_change = "禁用";
      } else if (this.info == "是否确认删除该网吧？") {
        this.delBar();
        return;
      } else {
        var status_type = "resetpwd";
      }

      this.deleteVisible = false;
      var param = {
        id: parseInt(this.rowId), // 如果operation_type是agent，那么这里是代理商id，否则是网吧id
        op: status_type, // 启用，请传enable,禁用，请传disable，删除，请传delete
      };
      sysApi
        .dele_use(param)
        .then((data) => {
          if (data.code == 200) {
            this.$message({
              message: data.info,
              type: "success",
            });
            if (status_type == "del") {
              this.tableData.splice(this.index, 1);
            } else if (status_type == "enable" || status_type == "disable") {
              this.tableData[this.index].status = status_change;
            }
          }
        })
        .catch((err) => console.log("请求异常信息:" + err));
    },

    /** 编辑按钮点击事件 **/
    changeBtn(index, row) {
      //this.index=index;
      //this.changeAgentData = Object.assign({},row,true);
      this.changeAgentData.ScanRatio = row.ScanRatio;
      this.changeAgentData.byUprice = row.byUprice;
      this.changeAgentData.name = row.name;
      this.changeAgentData.account = row.account;
      this.rowId = row.id;
      this.index = index;
      if (row.account == "国代") {
        this.level_own = 1;
      } else if (row.account == "一级代理") {
        this.level_own = 2;
      } else if (row.account == "二级代理") {
        this.level_own = 3;
      }

      this.changeAgent = true;
      console.log(row);
    },
    changeBar(index, row) {
      if (window.localStorage.getItem("account_number") === "liuming") {
        this.showBar = false;
        this.showBarCount = false;
      } else {
        if (row.status == "已到期") {
          this.showBarCount = false;
        } else {
          this.showBarCount = true;
        }
      }
      this.selectRow = row;
      console.log(row);
      this.rowId = row.net_bar_id;
      this.changeBarDialog = true;
      this.changeBarDialogData.Name = row.Name;
      this.changeBarDialogData.count = row.count;
      this.changeBarDialogData.bar_remark = row.bar_remark;
      this.changeBarDialogData.ip = row.ip;
      this.changeBarDialogData.ip = row.bar_remark;
    },

    // 確定修改按鈕
    changeOkBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var scan = this.changeAgentData.ScanRatio;
          var params = {
            id: parseInt(this.rowId),
            scan_code_ratio: parseFloat(this.changeAgentData.ScanRatio),
            recharge_price: parseFloat(this.changeAgentData.byUprice),
          };
          sysApi
            .create_agent(params)
            .then((res) => {
              if (res.success === true) {
                this.changeAgent = false;
                this.$message({
                  type: "success",
                  message: res.info,
                });
                var price_had = Number(this.changeAgentData.byUprice);
                this.tableData[this.index].byUprice = price_had.toFixed(2);
                this.tableData[this.index].ScanRatio = Number(
                  this.changeAgentData.ScanRatio
                ).toFixed(2);
              }
            })
            .catch((err) => console.log("请求异常信息:" + err));
        } else {
          return false;
        }
      });
    },

    search() {
      if (this.agentListBoolean) {
        this.currentPage = 1;
        this.init(this.sort);
      } else {
        this.currentPage1 = 1;
        this.init1();
      }
    },
    /** 分页条点击事件 **/
    handleCurrentChange(val) {
      this.currentPage = parseInt(`${val}`);
      this.init(this.sort);
    },
    handleCurrentChange1(val) {
      this.currentPage1 = parseInt(`${val}`);
      this.init1(this.form.barStatus);
    },
    //mac求和self_sum_mac
    macLiveAll(){
      let param={
        start_time:this.start_at,
        end_time:this.end_at,
      }
      sysApi
        .self_sum_mac(param)
        .then((data) => {
          if(data.code==1){
             this.nextmacLiveAll=data.nextMac;
             this.selfmacLive=data.selfMac
          }
          console.log(data);
        })
    },
    // init
    init(sort) {
      if (this.form.level == "国代") {
        this.form.level = 1;
      }
      this.loading = true;
      let sortText = "";
      if (sort) {
        sortText = sort;
      } else {
        sortText = 1;
      }
      var param = {
        page: this.currentPage,
        search: this.form.searchKey,
        sort: sortText,
        agenttype: this.form.level,
        start_time:this.start_at,
        end_time:this.end_at,
        mac:1,
      };
      sysApi
        .daili_list(param)
        .then((data) => {
          // for (var i in data.data) {
          //   if (data.data[i].type == "一级代理") {
          //     data.data[i].type = "国代";
          //   } else if (data.data[i].type == "二级代理") {
          //     data.data[i].type = "一级代理";
          //   } else if (data.data[i].type == "三级代理") {
          //     data.data[i].type = "二级代理";
          //   } else {
          //     data.data[i].type = "普通网吧";
          //   }
          // }
          
          this.tableData = data.data;
          this.total = data.total_count;
          this.loading = false;
          console.log(data);
        })
        .catch((err) => console.log("请求异常信息:" + err));
    },
    init1(status) {
      this.loading2 = true;
      let param = null;
      if (typeof status === "undefined") {
        param = {
          page: this.currentPage1,
          search: this.form.searchKey,
          bar_status: 0,
        };
      } else {
        if (status === "全部") {
          status = 0;
        }
        param = {
          page: this.currentPage1,
          search: this.form.searchKey,
          bar_status: status,
        };
      }

      sysApi
        .bar_list(param)
        .then((data) => {
          this.tableData1 = data.data;
          this.total1 = data.total_count;
          this.loading2 = false;
          console.log(data);
        })
        .catch((err) => console.log("请求异常信息:" + err));
    },
    inputCanEdit() {
      this.showBtn = false;
      this.showSpan = true;
    },
    renderEmotionValue(creatElement, { column, $index }) {
      return (
        <el-dropdown onCommand={this.handleCommand}>
          <span class="el-dropdown-link">
            渠道等级 <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">一级</el-dropdown-item>
            <el-dropdown-item command="2">二级</el-dropdown-item>
            <el-dropdown-item command="3">三级</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      );
    },
    handleCommand(command) {
      this.form.level = Number(command);
      this.init();
    },
  },
};
</script>
<style scope>
.app-containerTest {
  /* height: 520px; */
}
.dls_list table td {
  padding: 8px !important;
}

.content-wrapper .content {
  /* padding: 1.25rem 1.25rem 0 1.25rem; */
}

.tab_span {
  height: 37px;
  line-height: 37px;
  font-size: 14px;
}

.tab_span span {
  display: block;
  float: left;
  width: 200px;
  text-align: center;
  cursor: pointer;
  background: #fff;
}

.tab_span span.active {
  background: #409eff;
  color: #fff;
}

.el-table td,
.el-table th {
  padding: 10px 0 !important;
}

.ul_div {
  overflow: hidden;
  width: 100% !important;
  /* position:fixed;
        bottom:20px; */
  border-top: 1px solid #333;
  border-bottom: 1px solid #333;
  border-right: 1px solid #333;
  margin-bottom: 15px !important;
  height: 50px;
  /* background: #fff !important; */
}
 /deep/ .el-input__inner{
      height: 50px !important;
      background-color: #F5F5F5;
      border: 1px solid #DDDDDD;
      color: #999999;
    }
.ul_div li {
  float: left;
  margin-right: 50px;
  line-height: 50px;
  list-style: none;
  color: #333;
}

.ul_div li.li_li {
  width: 5px;
  background: #409eff;
  height: 50px;
  margin-right: 10px;
}

#account .el-form-item {
  margin-bottom: 22px;
}

#account .el-button {
  margin-left: 20px;
}

#account .recharge_time {
  width: 250px;
}
.input_width {
  width: 260px;
}
#account .el-form-item {
  display: inline-block;
}

#account .el-form-item__content {
  display: inline-block;
}

.agent_add .el-form-item__content {
  margin-left: 0px !important;
}

.agent_add .el-form-item {
  margin-bottom: 20px !important;
  display: block !important;
}

.agent_add_a .el-form-item {
  margin-bottom: 20px !important;
  display: block !important;
}

.agent_add_a .el-form-item__content {
  margin-left: 0px !important;
}

.sao_con {
  width: 500px;
  height: 300px;
  background: #fff;
  position: fixed;
  top: 20%;
  left: 50%;
  margin-left: -250px;
  z-index: 10000;
}

.sao_title {
  display: flex;
}

.searck_agent_btn {
  margin-left: 10px;
}

.sao_title_div {
  text-align: center;
  display: block;
  flex: 10;
  margin-top: 20px;
  font-size: 16px;
}

.el-dialog__headerbtn {
  display: block;
  flex: 2;
}

.sao_contain {
  display: flex;
  width: 90%;
  margin: 20px auto;
}

.saomiao_img {
  flex: 3;
}

.saomiao_right {
  flex: 9;
  padding-left: 10px;
}

.saomiao_right div {
  height: 35px;
  line-height: 35px;
}

.sao_Mask {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
}
.table_title {
      border: 1px solid #ebeef5;
      border-bottom: 0px;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      height: 49px;
      line-height: 49px;
      background: #f1f6f9;
    }
.submit_btn {
  width: 120px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  margin: 50px auto 0;
  background-color: #409eff;
  border-color: #409eff;
}

.agent_add .el-form-item__content,
.agent_add_a .el-form-item__content {
  width: 60%;
}

.el-input--suffix .el-input__inner {
  padding-right: 15px !important;
}
#account .el-upload__tip {
  display: inline-block;
  margin-left: 20px;
}

.content-wrapper .content {
  /* padding: 1.25rem 1.25rem 0 1.25rem; */
}
</style>



